export default __webpack_public_path__ + "static/media/full_burger.ea40e419.svg";